// Service for ICS input/output mappings (production_inputs + raw_material)
import api from './api';

export interface InputOutputProduct {
  item_number: string;
  item_english_name: string | null;
  item_chinese_name: string | null;
  raw_material_count: number;
}

export interface InputOutputRawMaterial {
  item_number: string;
  item_english_name: string | null;
  item_chinese_name: string | null;
  preference: number | null;
  yield_factor: number | null;
  labor_factor: number | null;
  batch_size: number | null;
  packing_size: number | null;
  team_size: number | null;
  average_daily_production: number | null;
  comments: string | null;
}

export interface RawMaterialSearchResult {
  item_number: string;
  item_english_name: string | null;
  item_chinese_name: string | null;
  packing: string | null;
}

const inputOutputMappingService = {
  async getProducts(): Promise<InputOutputProduct[]> {
    const response = await api.get('/production/byproduct-mappings/input-output-mappings/products');
    return response.data.products;
  },

  async getMappings(product: string): Promise<InputOutputRawMaterial[]> {
    const response = await api.get('/production/byproduct-mappings/input-output-mappings', {
      params: { product },
    });
    return response.data.rawMaterials;
  },

  async searchRawMaterials(query: string): Promise<RawMaterialSearchResult[]> {
    const response = await api.get('/production/byproduct-mappings/input-output-mappings/search-raw-materials', {
      params: { q: query },
    });
    return response.data.items;
  },

  async createMapping(data: {
    product_item_number: string;
    raw_material_item_number: string;
    preference: number;
  }): Promise<void> {
    await api.post('/production/byproduct-mappings/input-output-mappings', data);
  },

  async updatePreference(data: {
    product_item_number: string;
    raw_material_item_number: string;
    preference: number;
  }): Promise<void> {
    await api.put('/production/byproduct-mappings/input-output-mappings/preference', data);
  },

  async deleteMapping(data: {
    product_item_number: string;
    raw_material_item_number: string;
  }): Promise<void> {
    await api.delete('/production/byproduct-mappings/input-output-mappings', { data });
  },
};

export default inputOutputMappingService;
